// Inquiry forms (corporate spec §4.1, §2.3): optional date when "flexible" is ticked, honeypot, analytics on the
// confirmation page, phone-click tracking, and pre-filling the full form from the estimate calculator.
const track = (name, params = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: name, ...params });
  if (typeof window.gtag === 'function') window.gtag('event', name, params);
  try { window.Shopify?.analytics?.publish?.(name, params); } catch (error) { /* analytics must never break the form */ }
};

const STORAGE_KEY = 'inquiry:submitted';
const valueOf = (form, field) => form.querySelector(`[name="contact[${field}]"]`)?.value || '';

for (const form of document.querySelectorAll('form[data-inquiry-form]')) {
  const date = form.querySelector('[data-inquiry-date] input[type="date"]');
  const flexible = form.querySelector('[data-inquiry-date] input[type="checkbox"]');

  if (date) date.min = new Date().toISOString().slice(0, 10);
  flexible?.addEventListener('change', () => { date.required = !flexible.checked; });

  form.addEventListener('submit', (event) => {
    if (form.querySelector('[data-inquiry-honeypot]')?.value) {
      event.preventDefault();
      return;
    }

    // The page reloads on success, so the event parameters are kept until the confirmation renders.
    const params = {
      headcount: valueOf(form, 'Headcount'),
      format: valueOf(form, 'Format'),
      city: valueOf(form, 'City'),
      occasion: valueOf(form, 'Occasion'),
      event_month: (valueOf(form, 'Preferred date') || '').slice(0, 7),
      form_variant: form.dataset.inquiryVariant,
    };
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ type: form.dataset.inquiryForm, params })); } catch (error) { /* private mode */ }
  });
}

if (document.querySelector('[data-inquiry-success]')) {
  try {
    const saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
    if (saved) {
      track(`${saved.type}_inquiry_submitted`, saved.params);
      sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch (error) { /* private mode */ }
}

for (const link of document.querySelectorAll('a[href^="tel:"][data-track-phone]')) {
  link.addEventListener('click', () => track('phone_click', { location: link.dataset.trackPhone }));
}

// The calculator dispatches "inquiry:prefill" with { headcount, format }; fill the full form and bring it into view.
document.addEventListener('inquiry:prefill', (event) => {
  const form = document.querySelector('form[data-inquiry-variant="full"]');
  if (!form) return;

  const { headcount, format } = event.detail || {};
  const pick = (select, test) => {
    const option = [...(select?.options || [])].find((o) => o.value && test(o.value));
    if (option) select.value = option.value;
  };

  if (headcount) {
    pick(form.querySelector('[name="contact[Headcount]"]'), (value) => {
      const [low, high] = value.replace('+', '–100000').split('–').map((n) => Number(n.replace(/\D/g, '')));
      return headcount >= low && headcount <= high;
    });
  }
  if (format) pick(form.querySelector('[name="contact[Format]"]'), (value) => value.toLowerCase().startsWith(format === 'bar' ? 'perfume bar' : 'seated'));

  form.scrollIntoView({ behavior: 'smooth', block: 'start' });
  const firstEmpty = [...form.querySelectorAll('input[required], select[required]')].find((field) => !field.value);
  (firstEmpty || form.querySelector('input, select'))?.focus({ preventScroll: true });
});
